enum ImportErrorType {
  NoMatchingRandom = 0,
  NoMatchingTest = 1,
}

export default ImportErrorType
